(function () {
  'use strict';


  function suppressLegacySignupPopup() {
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]').forEach(function (dialog) {
      dialog.remove();
    });
    if (document.body) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  function watchLegacySignupPopup() {
    suppressLegacySignupPopup();
    if (!document.body || document.body.dataset.tpLegacyPopupWatch === 'true') return;
    document.body.dataset.tpLegacyPopupWatch = 'true';
    new MutationObserver(suppressLegacySignupPopup).observe(document.body, { childList: true, subtree: true });
  }

  function initSliderProgress() {
    document.querySelectorAll('.main-slideshow').forEach(function (slider) {
      if (slider.dataset.tpProgressReady === 'true') return;
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.carousel__slide'));
      if (slides.length < 2 || typeof Flickity === 'undefined') return;

      var flkty = Flickity.data(slider);
      if (!flkty) {
        window.setTimeout(initSliderProgress, 250);
        return;
      }

      slider.dataset.tpProgressReady = 'true';
      slider.classList.add('tp-has-progress');

      var progress = document.createElement('div');
      progress.className = 'tp-slider-progress';
      progress.setAttribute('aria-label', 'Slider navigation');

      var segments = slides.map(function (_, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tp-slider-progress__segment';
        button.setAttribute('aria-label', 'Gå til slide ' + (index + 1));
        var fill = document.createElement('span');
        fill.className = 'tp-slider-progress__fill';
        button.appendChild(fill);
        button.addEventListener('click', function () { flkty.select(index); });
        progress.appendChild(button);
        return button;
      });

      slider.appendChild(progress);

      function durationFor(index) {
        var configured = parseInt(slider.dataset.autoplay, 10);
        var fallback = Number.isFinite(configured) && configured > 0 ? configured : 5000;
        var video = slides[index] && slides[index].querySelector('video');
        if (video && Number.isFinite(video.duration) && video.duration > 0) {
          return Math.max(700, (video.duration - (video.currentTime || 0)) * 1000);
        }
        return fallback;
      }

      function activate(index) {
        segments.forEach(function (segment, i) {
          segment.classList.remove('is-active', 'is-complete');
          segment.style.removeProperty('--tp-slide-duration');
          if (i < index) segment.classList.add('is-complete');
        });

        var active = segments[index];
        if (!active) return;
        var video = slides[index] && slides[index].querySelector('video');

        function start() {
          active.style.setProperty('--tp-slide-duration', durationFor(index) + 'ms');
          void active.offsetWidth;
          active.classList.add('is-active');
        }

        if (video && (!Number.isFinite(video.duration) || video.duration <= 0)) {
          video.addEventListener('loadedmetadata', start, { once: true });
          active.style.setProperty('--tp-slide-duration', '5000ms');
          active.classList.add('is-active');
        } else {
          start();
        }
      }

      flkty.on('select', function () { activate(flkty.selectedIndex); });
      activate(flkty.selectedIndex || 0);

      document.addEventListener('visibilitychange', function () {
        var fill = progress.querySelector('.is-active .tp-slider-progress__fill');
        if (fill) fill.style.animationPlayState = document.hidden ? 'paused' : 'running';
      });
    });
  }

  function initNewsletterPopup() {
    var popup = document.getElementById('tp-newsletter-popup');
    if (!popup || popup.dataset.ready === 'true') return;
    popup.dataset.ready = 'true';

    var key = 'tpNewsletterPopupStateV2';
    var form = popup.querySelector('#tp-newsletter-popup-form');
    var formView = popup.querySelector('[data-tp-popup-form-view]');
    var successView = popup.querySelector('[data-tp-popup-success-view]');
    var error = popup.querySelector('[data-tp-popup-error]');
    var submit = form && form.querySelector('[type="submit"]');
    var previousFocus = null;

    function storedState() {
      try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (_) { return null; }
    }

    function remember(state) {
      try { window.localStorage.setItem(key, JSON.stringify({ state: state, at: Date.now() })); } catch (_) {}
    }

    function openPopup() {
      previousFocus = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tp-popup-open');
      window.setTimeout(function () {
        var first = popup.querySelector('input');
        if (first) first.focus();
      }, 80);
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tp-popup-open');
      if (!storedState()) remember('dismissed');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    popup.querySelectorAll('[data-tp-popup-close]').forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        error.hidden = true;
        submit.disabled = true;
        submit.textContent = 'TILMELDER…';

        var formData = new FormData(form);
        var email = String(formData.get('contact[email]') || '').trim();
        var firstName = String(formData.get('contact[first_name]') || '').trim();
        var lastName = String(formData.get('contact[last_name]') || '').trim();

        var shopifyRequest = fetch(form.action, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' }
        });

        var klaviyoRequest = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Uvws6E', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'TU PRIMUM newsletter popup',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      first_name: firstName,
                      last_name: lastName,
                      properties: {
                        signup_source: 'TU PRIMUM newsletter popup'
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: 'W8FNUm'
                  }
                }
              }
            }
          })
        });

        shopifyRequest.catch(function () {
          return null;
        });

        klaviyoRequest.then(function (response) {
          if (!response.ok) {
            return response.text().then(function (detail) {
              throw new Error('Klaviyo signup failed: ' + response.status + ' ' + detail);
            });
          }
          remember('subscribed');
          formView.hidden = true;
          successView.hidden = false;
          popup.querySelector('[data-tp-copy-code]').focus();
        }).catch(function (signupError) {
          console.error('[TU PRIMUM newsletter]', signupError);
          error.hidden = false;
          submit.disabled = false;
          submit.textContent = 'TILMELD MIG';
        });
      });
    }

    var copyButton = popup.querySelector('[data-tp-copy-code]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = 'WELCOME10';
        var done = function () {
          popup.querySelector('[data-tp-copy-status]').textContent = 'Koden er kopieret.';
          copyButton.textContent = 'KOPIERET';
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(done);
        } else {
          var area = document.createElement('textarea');
          area.value = code;
          area.style.position = 'fixed';
          area.style.opacity = '0';
          document.body.appendChild(area);
          area.select();
          document.execCommand('copy');
          area.remove();
          done();
        }
      });
    }

    var state = storedState();
    var sevenDays = 7 * 24 * 60 * 60 * 1000;
    var shouldOpen = !state || (state.state === 'dismissed' && Date.now() - state.at > sevenDays);
    if (shouldOpen && !window.Shopify.designMode) window.setTimeout(openPopup, 4500);
    if (window.Shopify.designMode) window.setTimeout(openPopup, 500);
  }

  function init() {
    watchLegacySignupPopup();
    initSliderProgress();
    initNewsletterPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', initSliderProgress);
})();